import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Line extends Symbol2d {

  noText = true // No text for lines

  getFlattenedPaths (data, dimensions, handles) {
    // Overwriting b/c we return two paths for lines, one for the line and one for the fat click target
    return this.getPaths(data, dimensions, handles)
  }

  /*
   * Overwriting to always use the actual stroke width
   */
  _calculateStrokeWidth (data) {
    return parseInt(data.strokeWidth) || 0
  }

  getPaths (data, dimensions, handles) {
    const strokeWidth = data.strokeWidth || 0

    const _path = path()
    _path.moveTo(0, 0)
    _path.lineTo(dimensions.width + strokeWidth, 0)
    _path.closePath()

    const p = {
      path: _path.toString(),
      translate: [-strokeWidth / 2, 0],
    }

    return [p, Object.assign({}, p, {
      // Same path but with a fat stroke for the click target
      styles: {
        stroke: 'transparent',
        strokeWidth: '20px',
      }
    })]
  }

  getMiter () {
    return null // No miter for straight lines
  }
}
